<template>
  <CCard>
    <!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <CCardHeader>
      <slot name="header" class="d-flex align-center justify-space">
        <span><CIcon name="cil-grid" class="mr-2"/> {{caption}}</span>
        <CButton color="primary" class="px-4" @click="add()">Add Module</CButton>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 10 : 5"
        :dark="dark"
        pagination
		tableFilter
		sorter		
		itemsPerPageSelect
      >
        <template #status="{item}">
          <td>
            <CBadge :color="getBadge(item.status)">{{item.status}}</CBadge>
          </td>		  
        </template>
		<template #status="{item}">         
		  <td>
			<CBadge :color="getBadge(item.status)" v-on:click="change_status(item.Module_Id);"	:id="'status_'+item.Module_Id">{{item.status}}</CBadge>
          </td>
        </template>
		<template #action="{item}">         
		  <td>
            <CButton color="primary" class="mr-2" :color="getEdit(item.action)" @click="edit(item.Module_Id)">Edit</CButton>
			<!-- <CButton :color="getDelete(item.action)" @click="deletepop(item.Module_Id)">Delete</CButton>			 -->
          </td>
        </template>
      </CDataTable>
	  <CModal
      :show.sync="myModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Delete"
      size="sm"
      color="dark"
    >
      Are you wan't to delete this?
      <template #header>
        <h6 class="modal-title">Delete</h6>
        <CButtonClose @click="myModal = false" class="text-white"/>
      </template>
      <template #footer>
        <CButton @click="myModal = false" color="danger">Cancel</CButton>
        <!-- <CButton @click="deleteRow" color="success">Delete</CButton> -->
      </template>
    </CModal>  
	 
    </CCardBody>
  </CCard>
</template>

<script>
import axios from "axios";
export default {
  name: 'Manage_module',
  data () {
    return {
      myModal: false,
      isLoading: false
	}
  },
  props: {
    items: Array,
    fields: {
      type: Array,
      default () {
        return ['Module_Id','ModuleName', 'status','action']
      }
    },
    caption: {
      type: String,
      default: 'Manage_user'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    responsive: Boolean
  },
  methods: {
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
	getEdit (color) {
      return 'primary';
    },
	getDelete(color){
		return 'danger';
	},
	edit(id){				
		localStorage.setItem("edit_module_id",id); 		
		this.$router.push({path:'edit_modules'})
	},
	change_status(id){		
    var IsActive=$('#status_'+id).html();
    console.log(IsActive);
		if(IsActive=='Active'){
      IsActive="In-Active"
		}else{
      IsActive="Active"
      console.log(IsActive);
    }
		var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
		var token=localStorage.getItem("auth");	
		var requestInfo = {
      Module_Id: id,
      // ModuleName: ModuleName,
			Status:IsActive,
			Token:token,
			Session_User_Id:Session_User_Id,
		};		
		var data = JSON.stringify(requestInfo);				
		var self = this;
		var config = {
		  method: 'post',
		  url: apiURL+'ManageModule/UpdateModuleStatus',
		  headers: { 
			'Content-Type': 'application/json'
		  },
		  data : data
		};
    // debugger
    this.isLoading = true;
		axios(config)
		.then((result) => {	
      this.isLoading = false;		
			if(result.data.status_code==200){
				$('#status_'+id).html(IsActive);				
				this.$swal.fire({
					title: "Status", 
					text: "Status Change Successfully..", 
					type: "success"					  
				}).then(() => { 
						//location.reload();
				   }
				);				
			}else{
				this.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: result.data.message		 
				})				
			}
		  
		})
		.catch((error) => {	
      this.isLoading = false;		
			this.$swal.fire({
			  icon: 'error',
			  title: 'Oops...',
			  text: 'Something went wrong!'		 
			})
		});
	},
	add(){
		//console.log('add');
		this.$router.push({path:'add_modules'})
	},
  }
}
</script>